import { useEffect, useState } from 'react';
import api from '../lib/api';
import { setPageMeta } from '../lib/shop';

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [cat, setCat] = useState('');

  useEffect(() => {
    setPageMeta('FAQ', 'Frequently asked questions about VQ Health research supply, COAs, shipping and payments.');
    api.get('/faqs').then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  const cats = [...new Set(faqs.map((f) => f.category))];
  const list = cat ? faqs.filter((f) => f.category === cat) : faqs;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="faq-page">
      <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#8A8F95]">Support</p>
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-2 mb-8">Frequently Asked Questions</h1>
      <div className="flex flex-wrap gap-1.5 mb-8">
        <button onClick={() => setCat('')} className={`px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-wider border ${!cat ? 'bg-[#0B0F12] text-white border-[#0B0F12]' : 'border-[#D8D8D0]'}`}>All</button>
        {cats.map((c) => (
          <button key={c} data-testid={`faq-cat-${c.toLowerCase().replace(/[^a-z]+/g, '-')}`} onClick={() => setCat(cat === c ? '' : c)}
            className={`px-3 py-1.5 font-mono2 text-[10px] uppercase tracking-wider border ${cat === c ? 'bg-[#0B0F12] text-white border-[#0B0F12]' : 'border-[#D8D8D0] hover:border-[#0B0F12]'}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="space-y-3">
        {list.map((f) => (
          <details key={f.id} className="bg-white border hairline group" data-testid={`faq-item-${f.id}`}>
            <summary className="cursor-pointer px-5 py-4 font-display font-bold uppercase tracking-wide text-base list-none flex justify-between items-center gap-4">
              {f.question}
              <span className="font-mono2 text-[#8A8F95] group-open:rotate-45 transition-transform text-xl leading-none shrink-0">+</span>
            </summary>
            <p className="px-5 pb-5 text-sm text-[#575B60] leading-relaxed">{f.answer}</p>
          </details>
        ))}
      </div>
      <p className="text-sm text-[#575B60] mt-10 text-center">
        Still stuck? Email <a className="underline" href="mailto:support@vqhealth.co.uk">support@vqhealth.co.uk</a> — we reply within one working day.
      </p>
    </div>
  );
}
